import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ToolSidebar from "../utils/ToolSideBar";
import { API_URL, authFetch } from "../utils/auth";
import "../../css/staff/InternalWorkspace.css";

export default function StaffProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");

  const loadProjects = useCallback(async function loadProjects() {
    setLoading(true);
    const params = new URLSearchParams();
    if (search) params.set("search", search);
    if (status) params.set("status", status);
    try {
      const response = await authFetch(`${API_URL}/staff/projects/${params.toString() ? `?${params}` : ""}`);
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || "Unable to load projects.");
      setProjects(data.results || []);
      setError("");
    } catch (err) {
      setError(err.message || "Unable to load projects.");
    } finally {
      setLoading(false);
    }
  }, [search, status]);

  useEffect(() => { loadProjects(); }, [loadProjects]);

  return (
    <div className="staff-shell">
      <ToolSidebar active="projects" />
      <main className="staff-page internal-page">
        <header className="staff-header"><span>SCD Delivery</span><h1>Projects</h1><p>Role-scoped project delivery queue.</p></header>
        <section className="staff-card internal-toolbar">
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search client, email, or project" />
          <select value={status} onChange={(e) => setStatus(e.target.value)}><option value="">All statuses</option>{["awaiting_assignment","planning","design","client_review","development","quality_assurance","ready_to_launch","launched","on_hold","completed","canceled"].map((item) => <option key={item} value={item}>{item.replaceAll("_", " ")}</option>)}</select>
          <button type="button" onClick={loadProjects}>Filter</button>
        </section>
        <section className="staff-card">
          {loading ? <p>Loading projects...</p> : error ? <p>{error}</p> : projects.length === 0 ? <p className="staff-empty inline">No projects match those filters.</p> : (
            <div className="staff-table-wrap"><table className="staff-table internal-table"><thead><tr><th>Project</th><th>Client</th><th>Status</th><th>Health</th><th>PM</th><th>Team</th><th>Last Activity</th></tr></thead><tbody>{projects.map((project) => <tr key={project.id}><td><Link to={`/projects/${project.id}`} className="staff-strong-link">{project.project_name}</Link><small>{project.referring_partner}</small></td><td>{project.client?.name}<small>{project.client?.email}</small></td><td>{project.delivery_status_label}</td><td><span className={`health-pill health-${project.health}`}>{project.health_label}</span></td><td>{project.project_manager?.name || "Unassigned"}</td><td>{(project.team || []).map((item) => item.role_label).join(", ") || "None"}</td><td>{project.last_activity?.summary || "No activity"}</td></tr>)}</tbody></table></div>
          )}
        </section>
      </main>
    </div>
  );
}